/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-null/no-null */
import { Chip, ChipProps } from '@mui/material';
import { DateRange, DateRangePicker } from '@mui/x-date-pickers-pro';
// eslint-disable-next-line import/no-internal-modules
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import { format } from 'date-fns';
import { useState, forwardRef, useCallback } from 'react';

import { SearchBoxAutocompleteValue, SearchBoxMenuOption } from './search-box-types';
interface SearchBoxDateRangeSegmentProps {
    option: SearchBoxMenuOption;
    onEdit: (index: number, newValue?: SearchBoxAutocompleteValue, selectedOption?: SearchBoxMenuOption) => void;
    index: number;
    value?: DateRange<Date>;
    className: string;
    onDelete: (event: any) => void;
    searchBoxName: string;
}

export const SearchBoxDateRangeSegment = forwardRef<HTMLDivElement, SearchBoxDateRangeSegmentProps>(
    ({ option, onEdit, index, className, value }, ref) => {
        const handleRemove = useCallback<NonNullable<ChipProps['onDelete']>>(() => {
            onEdit(index - 1);
        }, [index, onEdit]);
        const [focused, setFocused] = useState(!value);

        return focused ? (
            <DateRangePicker<Date>
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                slots={{ field: SingleInputDateRangeField }}
                name='allowedRange'
                calendars={2}
                value={value}
                onAccept={(newValue) => {
                    onEdit(index - 1, {
                        optionName: option.name,
                        optionRelation: 'eq',
                        optionValue: newValue,
                    });
                    setFocused(false);
                }}
                slotProps={{
                    popper: {
                        className: `${option.name}-popper`,
                    },
                    textField: {
                        inputProps: {
                            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
                            sx: { minWidth: 224 - 10 * (value ?? []).filter((val) => !!val).length },
                        },
                        onBlur: () => {
                            if (!document.querySelector(`.${option.name}-popper`)) {
                                setFocused(false);
                            }
                        },

                        onKeyDown: (event) => {
                            event.stopPropagation();
                        },
                        onMouseDown: (event) => {
                            event.stopPropagation();
                        },
                    },
                }}
                autoFocus
                onClose={() => {
                    setFocused(false);
                }}
            />
        ) : (
            <Chip
                tabIndex={-1}
                {...{ 'data-tag-index': index }}
                className={className}
                label={value
                    ?.map((val) => {
                        return val ? format(val, 'MM/dd/yyyy') : '';
                    })
                    .join(' – ')}
                sx={{ borderBottomLeftRadius: 0, borderTopLeftRadius: 0 }}
                size='medium'
                ref={ref}
                onDelete={handleRemove}
                onFocus={() => {
                    setFocused(true);
                }}
                onClick={() => {
                    setFocused(true);
                }}
            />
        );
    },
);
